module.exports = __webpack_public_path__ + "static/media/profileImage.9b9f6e89.jpg";